import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useAuth } from "../context/AuthContext";

const StatusBar = () => {
  const { user } = useAuth();
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const formatter = new Intl.DateTimeFormat("de-AT", {
        timeZone: "Europe/Vienna",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
      setCurrentTime(formatter.format(new Date()));
    };

    updateTime();
    const timer = setInterval(updateTime, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#1b1d3e",
        color: "grey.100",
        py: 0.5,
        borderTop: "1px solid",
        borderColor: "divider",
        zIndex: (theme) => theme.zIndex.appBar - 1,
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          width: "100%",
        }}
      >
        <Typography variant="caption" sx={{ fontSize: "0.75rem" }}>
          {currentTime} Uhr
        </Typography>
        <Typography variant="caption" sx={{ fontSize: "0.75rem" }}>
          {user ? user.username : "Nicht eingeloggt"}
        </Typography>
      </Box>
    </Box>
  );
};

export default StatusBar;

